import { render, staticRenderFns } from "./NewsAdd.vue?vue&type=template&id=10d82e5b&scoped=true"
import script from "./NewsAdd.vue?vue&type=script&lang=js"
export * from "./NewsAdd.vue?vue&type=script&lang=js"
import style0 from "./NewsAdd.vue?vue&type=style&index=0&id=10d82e5b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d82e5b",
  null
  
)

export default component.exports